import React from "react";

type AlarmContextType = {};

const defaultValue: AlarmContextType = {};

export const AlarmContext = React.createContext(defaultValue);

export default function AlarmContextProvider(props: {
  children: React.ReactNode;
}) {
  return (
    <AlarmContext.Provider value={{}}>{props.children}</AlarmContext.Provider>
  );
}
